import { Debug } from '@svt/debug';
import { supportsLocalStorage } from './environment';

const error = Debug('play:loadPersistentActions:error');

export const LOCAL_STORAGE_KEY = 'persistent_state';

export function loadPersistentActions(dispatch, typeToDispatch) {
    if (!supportsLocalStorage()) {
        return {};
    }

    try {
        // Load actions from local storage and execute them
        const actions = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');

        Object.keys(actions).forEach((type) => {
            if (!typeToDispatch || typeToDispatch === type) {
                const payload = actions[type];

                dispatch({ type: type, payload });
            }
        });

        dispatch({ type: 'PERSISTENT_STATE_LOADED', payload: true });
    } catch (err) {
        error('Error while reading data from localStorage: %s', err.message);
    }
}
